/** Move one id up or down inside an ordered list. Returns null when it cannot move. */
export function moveChecklistId(ids: readonly string[], id: string, direction: -1 | 1): string[] | null {
  const index = ids.indexOf(id);
  const next = index + direction;
  if (index < 0 || next < 0 || next >= ids.length) return null;
  const copy = [...ids];
  const [row] = copy.splice(index, 1);
  copy.splice(next, 0, row!);
  return copy;
}
